import { tv } from '@/ui/utils'

export const pageShellStyles = tv({
	slots: {
		row: 'flex-1 w-full flex-row bg-ground',
		column: 'flex-1 lg:max-w-[780px]',
		content: 'flex-grow px-5 py-8 lg:px-14 lg:py-16',
		photoPane: 'hidden lg:flex flex-1',
	},
})
